import { EnderecoModel } from '@/models/commons/EnderecoModel';
import { ContaBancariaModel } from '@/models/commons/ContaBancariaModel';
import { ITelefoneModel } from '@/models/commons/TelefoneModel';
import { TipoPrestadorModel } from "@/models/cadastros/saude/TipoPrestadorModel";

export interface DadosBasicosPrestadorModel {
    cpfCnpj: string;
    nome: string;
    tipoPessoa: TipoPessoa;
    tipoPrestador?: TipoPrestadorModel;
    flagCadastroCPOM: boolean;
    email: string;
    telefones: ITelefoneModel[];
    endereco: EnderecoModel;
    contaBancaria: ContaBancariaModel;
    ativo: boolean;
}

export enum TipoPessoa {
    FISICA = 'FISICA',
    JURIDICA = 'JURIDICA'
}

export class DadosBasicosController {
    public static isPF(document: string): boolean {
        return document.replace(/\D/g, '').length <= 11;
    }

    public static tipoPessoa(document: string): TipoPessoa {
        return this.isPF(document) ? TipoPessoa.FISICA : TipoPessoa.JURIDICA;
    }
}